import { Transaction } from '../models';
import { EntityActions, TransactionActions } from '../actions/consts';


type TransactionsUIState = {
  loading: boolean;
  errorMessage: string;
  currentList: [];
  filter: any,
  currentPage: number
};

type TransactionsState = {
  entities: {[id: string]: Transaction};
  ui: TransactionsUIState;
};

const defaultState: TransactionsState = {
  entities: {},
  ui: {
    currentList: [],
    loading: false,
    errorMessage: '',
    filter: null,
    currentPage: 0,
  }
};


export function transactions(state: TransactionsState = defaultState, action) {
  switch (action.type) {
    case EntityActions.ADD_ENTITIES:
      return {
        ...state,
        entities: {
          ...state.entities,
          ...action.entities.transactions,
        }
      };
    case TransactionActions.LOAD_REQUEST:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: true,
          errorMessage: '',
        }
      };
    case TransactionActions.LOAD_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
        }
      };
    case TransactionActions.LOAD_ERROR:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: action.error.errorMessage,
        }
      };
    case TransactionActions.LOAD_LIST_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
          currentList: action.result,
        }
      };
    case TransactionActions.SET_CURRENT_PAGE:
      return {
        ...state,
        ui: {
          ...state.ui,
          currentPage: action.currentPage,
        }
      };
    default:
      return state;
  }
}
